var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"we-product-icon"},[_c('font-awesome-icon',{class:_vm.color + '--text',style:({ height: _vm.size + 'px', width: _vm.size + 'px' }),attrs:{"icon":"cube"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }